import { useAuthStore } from '@/stores/auth';
import { logoutPlatformSession } from './api';
import { markExplicitLogout } from './explicit-logout';
import { clearPendingAuthorizationQuery } from './mcp-consent';
import {
  beginSignOut,
  leavingSessionAccessToken,
  setSignOutStatus,
  signOutGeneration,
  useSignOutStore,
} from './sign-out-state';

/**
 * "Sair" do backoffice (C8 da change platform-backoffice-hardening, revisão E16).
 *
 * Sempre sai daqui, na hora: a marca do "Sair" explícito vai para o `sessionStorage` (enquanto ela
 * existir, o carregamento não restaura sessão pelo cookie), a memória é limpa e a autorização de
 * agente pendente nesta aba sai também. Só depois o `POST /logout` vai à API, com o access que a
 * memória tinha. Se ele falhar, o cookie pode seguir vivo, mas a sessão não volta sozinha: a tela
 * de login mostra o erro e o "Tentar de novo" ({@link retrySignOut}).
 *
 * Quem chama navega para o login logo depois; a promessa devolvida é só a da API.
 */
export function signOut(): Promise<void> {
  const accessToken = useAuthStore.getState().accessToken;
  markExplicitLogout();
  useAuthStore.getState().clearAuth();
  clearPendingAuthorizationQuery();
  beginSignOut(accessToken);
  return attemptLogout();
}

/** "Tentar de novo" da tela de login, só depois de uma falha. */
export function retrySignOut(): Promise<void> {
  if (useSignOutStore.getState().status !== 'failed') return Promise.resolve();
  setSignOutStatus('pending');
  return attemptLogout();
}

async function attemptLogout(): Promise<void> {
  const started = signOutGeneration();
  let outcome: 'idle' | 'failed';
  try {
    await logoutPlatformSession(leavingSessionAccessToken());
    outcome = 'idle';
  } catch {
    outcome = 'failed';
  }
  // Um login concluído no meio abriu outra geração: o desfecho deste "Sair" não vale mais.
  if (signOutGeneration() === started) setSignOutStatus(outcome);
}
